import * as React from 'react';
const SvgNotEqual = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 36 36" fill="none" {...props}>
        <circle cx={18} cy={18} r={18} fill="url(#not-equal_svg__paint0_linear)" />
        <path
            d="M15.707 13.707a1 1 0 00-1.414-1.414l1.414 1.414zm-1.414 10a1 1 0 001.414-1.414l-1.414 1.414zm0-11.414L10 16.586 11.414 18l4.293-4.293-1.414-1.414zM10 19.414l4.293 4.293 1.414-1.414L11.414 18 10 19.414zm0-2.828a2 2 0 000 2.828L11.414 18 10 16.586zM20.293 13.707a1 1 0 011.414-1.414l-1.414 1.414zm1.414 10a1 1 0 01-1.414-1.414l1.414 1.414zm0-11.414L26 16.586 24.586 18l-4.293-4.293 1.414-1.414zM26 19.414l-4.293 4.293-1.414-1.414L24.586 18 26 19.414zm0-2.828a2 2 0 010 2.828L24.586 18 26 16.586z"
            fill="#fff"
        />
        <defs>
            <linearGradient
                id="not-equal_svg__paint0_linear"
                x1={0}
                y1={0}
                x2={43.321}
                y2={15.383}
                gradientUnits="userSpaceOnUse"
            >
                <stop stopColor="#5449A1" />
                <stop offset={0} stopColor="#594EAB" />
                <stop offset={1} stopColor="#804ED9" />
            </linearGradient>
        </defs>
    </svg>
);
export default SvgNotEqual;
